<template>
<div>
    <v-dialog v-model="hideShow" width="720" persistent scrollable content-class="student-review-dialog" aria-label="点评学员">
      <v-card class="fc-dialog-card rv-card">
        <v-card-title class="fc-dialog-header">
          <span class="fc-dialog-symbol"><v-icon color="#d9363e" size="24">mdi-comment-edit-outline</v-icon></span>
          <div><h2>点评学员</h2><p>记录课堂表现，分享学员的作品与进步</p></div>
          <v-spacer />
          <v-btn icon aria-label="关闭点评学员" @click="cancel"><v-icon size="22">mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text class="fc-dialog-body rv-body">
          <div class="rv-student">
            <span class="rv-avatar">{{(studentName || '学').slice(0,1)}}</span>
            <div><span class="rv-label">点评学员</span><strong>{{studentName}}</strong></div>
            <span class="rv-mode">按学员点评</span>
          </div>
          <section class="rv-section" aria-label="课堂表现评分">
            <div class="rv-section-heading"><h3>课堂表现</h3><span>选择星级评分</span></div>
            <div class="rv-score">
              <v-rating v-model="rate.rateScore" color="#d99a31" background-color="#cbd4df" empty-icon="$ratingFull" hover />
              <span><strong>{{rate.rateScore}}</strong> / 5 分</span>
            </div>
          </section>
          <section class="rv-section" aria-label="课堂点评内容">
            <div class="rv-section-heading"><h3>课堂点评 <span class="rv-required">必填</span></h3></div>
            <v-textarea label="请输入课堂点评内容" placeholder="记录课堂表现、学习进步或课后练习建议" no-resize rows="4" v-model="rate.content" outlined dense clearable color="#d9363e" hide-details />
          </section>
          <section class="rv-section rv-works" aria-label="学员作品">
            <div class="rv-section-heading"><h3>学员作品 <span class="rv-optional">选填</span></h3><span>{{upload.imgList.length}} / 3 张</span></div>
            <p class="rv-help">可上传最多 3 张作品，选择合适比例裁剪。</p>
            <div class="rv-upload-tools">
              <div class="rv-upload-control"><cutImageUpload title="上传作品" :viewPrevImage="false" :boxWidth="800" :boxHeight="600" :cutWidth="600" :cutHeight="600" :rate="upload.cutRate" @success="uploadSuccess" /></div>
              <div class="rv-ratio"><span>图片比例</span><v-radio-group v-model="upload.cutRate" row hide-details class="rv-ratio-options"><v-radio color="#d9363e" label="1:1" value="1:1" /><v-radio color="#d9363e" label="3:4" value="3:4" /><v-radio color="#d9363e" label="4:3" value="4:3" /></v-radio-group></div>
            </div>
            <div v-if="upload.imgList && upload.imgList.length" class="rv-photo-grid">
              <div v-for="(item,index) in upload.imgList" :key="index" class="rv-photo">
                <v-img :src="imgPrev + item" height="112" :alt="'学员作品 ' + (index + 1)" />
                <v-btn color="white" small icon class="rv-photo-remove" :aria-label="'移除作品 ' + (index + 1)" @click="upload.imgList.splice(index,1)"><v-icon size="18">mdi-close</v-icon></v-btn>
              </div>
            </div>
          </section>
        </v-card-text>
        <v-card-actions class="fc-dialog-actions"><v-spacer /><v-btn text @click="cancel">取消</v-btn><v-btn depressed class="fc-confirm" color="#d9363e" @click="submitAddRate" :disabled="rate.submitting" :loading="rate.submitting">提交点评</v-btn></v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
	import * as qiniu from 'qiniu-js'
	import storage from "../config/storage"
	import utils from '../config/utils'
	import cutImageUpload from './cut_image_upload.vue'
	export default {
		name:"rate-student-class",
		components:{cutImageUpload},
		props: {
			//显示/隐藏。
			show: {
				type: Boolean,
				default: false
			},
			detailId:{
				type:String,
				default:""
			},
			studentName:{
				type:String,
				default:""
			}
			
		},
		watch:{
			show(newVal,oldVal){
				console.log("newVal",newVal);
				this.hideShow = newVal;
				if(this.hideShow){
					this.rate.content = "";
					this.rate.rateScore = 5;
					this.upload.imgList = [];
	
				}
			}
		},
		data(){
			return {
				imgPrev:"https://photo.youkeya.cn/",
				hideShow:this.show,
				rate:{
					submitting:false,
					rateScore:5,
					content:"",

				},
				upload: {
					cutRate:"1:1",
					imgList: [], //上传图片结果
				
				},
			}
		},
		mounted() {
			console.log("approve-record mounted");
		},
		methods:{
			uploadSuccess(e){
			
				if (this.upload.imgList && this.upload.imgList.length >= 3){
					this.$noty.error('最多上传3张照片');
					return
				}
				this.upload.imgList.push(e.key);
			},
			cancel(){
				this.$emit("cancel","");
			},
			submitAddRate() {
			
				if (!this.detailId) {
					this.$noty.error('ID不能为空');
					return
				}
				if (!this.rate.rateScore) {
					this.$noty.error('评分不能为空');
					return
				}
					
				if (!this.rate.content) {
					this.$noty.error('点评内容不能为空');
					return
				}
				let imgList = this.upload.imgList; // 上传的图片KEY
				
				
				this.rate.submitting = true;
				// api
				const that = this;
				let url = `/edu/class/record/detail/rate/create`;
				let postData = {
					detailId:this.detailId,
					rateScore:this.rate.rateScore,
					content:this.rate.content,
				};
				postData.imgList = imgList;
			
				this.axios.post(url, postData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("点评成功");
							
							that.rate.submitting = false;
							that.$emit("success","");
							return;
						} else {
							that.rate.submitting = false;
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.rate.submitting = false;
						that.$noty.error('网络请求失败');
					}
			
				});
			},
		}
	}
	
</script>

<style lang="scss" scoped src="../assets/styles/student-review.scss"></style>
